export default "__VITE_ASSET__cf7a0989__"